// TODO Low: Implement or remove?
export default new Vue({

});